module.exports = __webpack_public_path__ + "static/media/montiapp-large.ef399c06.jpg";